import { useLoginProvide } from '@/hooks/login';
import { MENU_LIST } from '@/type/auth';
import { MEMBER_DETAIL, MY_PRIVATE_SEA_PATH } from '@/type/router';
import { getPath } from '@/utils/path';
import { Empty } from 'ant-design-vue';
import { RouteRecordRaw, createRouter, createWebHashHistory } from 'vue-router';
import commonStore from '../store/common';

const getRedirectPath = () => {
  const path = JSON.parse(localStorage.getItem(MENU_LIST) || '{}');
  let resultPath = '';
  for (const key in path) {
    if (Object.prototype.hasOwnProperty.call(path, key)) {
      const element = path[key];
      if (element.path === '/myClass') {
        resultPath = '/myClass';
      }
    }
  }
  if (resultPath === '') {
    if (path[0]?.children && path[0]?.children.length) {
      resultPath = path[0]?.children[0].path;
    } else {
      resultPath = path[0]?.path;
    }
  }
  return resultPath;
};
// const redirect = () => {
// const common = commonStore();

//   let authUrl = common.allAuth.findIndex((item) => item.url === '/myClass');
//   if (authUrl < 0) {
//     return common.allAuth[0].child_menu[0].url;
//   } else {
//     return 'myClass';
//   }
// };

// let authUrl = common.allAuth.findIndex(item => item.url === '/myClass')

// 需要权限使用的路由
export const homeRouter = [
  {
    name: 'home',
    path: '/',
    meta: { auth: true },
    component: () => import('../pages'),
    redirect: getRedirectPath(),
    // redirect: '/myClass',
    children: [
      {
        name: 'newMyClass',
        path: '/newMyClass',
        meta: { auth: true },
        component: () => import('../pages/newMyClass'),
        children: [
          {
            name: 'newStudent',
            path: 'newStudent',
            component: () => import('@/pages/myClass/components/Students.jsx')
          },
          {
            name: 'newLesson',
            path: 'newLesson',
            component: () => import('@/pages/myClass/components/lessonPerformance/index.jsx')
          },
          {
            name: 'newClassLog',
            path: 'newClassLog',
            component: () => import('@/pages/myClass/components/ClassLog.jsx')
          },
          {
            name: 'newAllLesson',
            path: 'newAllLesson',
            component: () => import('@/pages/myClass/components/lessonPerformance/index.jsx')
          }
        ]
      },
      {
        name: 'myClass',
        path: '/myClass',
        meta: { auth: true },
        component: () => import('../pages/myClass'),
        children: [
          {
            name: 'student',
            path: 'student',
            component: () => import('@/pages/myClass/components/Students.jsx')
          },
          {
            name: 'lesson',
            path: 'lesson',
            component: () => import('@/pages/myClass/components/lessonPerformance/index.jsx')
          },
          {
            name: 'classLog',
            path: 'classLog',
            component: () => import('@/pages/myClass/components/ClassLog.jsx')
          },
          {
            name: 'allLesson',
            path: 'allLesson',
            component: () => import('@/pages/myClass/components/lessonPerformance/index.jsx')
          },
          {
            name: 'survey',
            path: 'survey',
            component: () => import('@/pages/myClass/components/Survey.jsx')
          }
        ]
      },
      {
        name: 'myTask',
        path: '/myTask',
        meta: { auth: false },
        redirect: '/myTask/task',
        component: () => import('@/pages/myTask/index'),
        children: [
          {
            name: 'task',
            path: '/myTask/task',
            component: () => import('@/pages/myTask/task/index')
          },
          {
            name: 'refundReview',
            path: '/myTask/refundReview',
            component: () => import('@/pages/myTask/refundReview/index')
          },
          // 回放跟课
          {
            name: 'replayCourse',
            path: '/myTask/replayCourse',
            component: () => import('../pages/myTask/replayCourse')
          },
          // 批改
          {
            name: 'correctOverview',
            path: '/myTask/correctOverview',
            component: () => import('../pages/myTask/correctOverview')
          },
          // 触达
          {
            name: 'stuTouch',
            path: '/myTask/stuTouch',
            component: () => import('../pages/myTask/stuTouch')
          }
        ]
      },
      {
        name: 'tools',
        path: '/commonTools',
        meta: { auth: true },
        component: () => import('@/pages/tools'),
        children: [
          {
            name: 'buy-course-link',
            path: '/commonTools/buyCourseLink',
            component: () => import('@/pages/tools/buy-course-link')
          },
          {
            name: 'class-add-course',
            path: '/commonTools/createCourse',
            component: () => import('@/pages/tools/class-add-course')
          },
          {
            name: 'class-manage',
            path: '/commonTools/classManage',
            component: () => import('@/pages/tools/class-manage')
          },
          {
            name: 'tools',
            path: '/commonTools/videoRecord',
            component: () => import('../pages/tools/mediaRecorder')
          },
          {
            name: 'micro-receipt',
            path: '/commonTools/microReceipt',
            component: () => import('@/pages/tools/micro-receipt')
          },
          {
            name: 'convert-give-lessons',
            path: '/commonTools/grantCourse',
            component: () => import('@/pages/tools/convert-give-lessons')
          },
          {
            name: 'search-student',
            path: '/commonTools/searchStudent',
            component: () => import('@/pages/tools/all-search')
          },
          {
            name: 'cps',
            path: '/commonTools/cpsList',
            component: () => import('@/pages/tools/cpsPoster')
          },
          {
            name: 'sms-record',
            path: '/commonTools/smsRecord',
            component: () => import('@/pages/tools/smsRecord')
          },
          {
            name: 'playback-status',
            path: '/commonTools/playbackStatus',
            component: () => import('@/pages/tools/playbackStatus')
          }
        ]
      },
      {
        // /admissionsService
        name: 'enrollment',
        path: '/enrollment', // 招生服务
        // meta: { auth: true },
        component: () => import('@/pages/enrollment'),
        children: [
          {
            name: 'myPrivateSea',
            path: MY_PRIVATE_SEA_PATH,
            component: () => import('@/pages/enrollment/myPrivateSea')
          },
          {
            name: 'orderDetail',
            path: '/enrollment/orderDetail',
            component: () => import('@/pages/enrollment/orderDetail')
          },
          {
            name: 'redBooklet',
            path: '/enrollment/redBooklet',
            component: () => import('@/pages/enrollment/redBookletDetail')
          },
          {
            name: 'ccSea',
            path: '/enrollment/ccSea',
            component: () => import('@/pages/enrollment/ccSea')
          },
          {
            name: 'teacherPrivateSea',
            path: '/enrollment/teacherPrivateSea',
            component: () => import('@/pages/enrollment/teacherPrivateSea')
          },
          {
            name: 'highPrivateSea',
            path: '/enrollment/highPrivateSea',
            component: () => import('@/pages/enrollment/highPrivateSea')
          }
          // 预测式外呼
          // {
          //   name: 'predictiveOutboundCall',
          //   path: '/enrollment/predictiveOutboundCall',
          //   component: () => import('@/pages/enrollment/predictiveOutboundCall')
          // },
          // 接线列表
          // {
          //   name: 'wiringList',
          //   path: '/enrollment/wiringList',
          //   component: () => import('@/pages/enrollment/wiringList')
          // }
        ]
      },
      {
        name: 'manageTool',
        path: '/manageTool',
        component: () => import('@/pages/manageTool'),
        children: [
          {
            name: 'teamMember',
            path: MEMBER_DETAIL,
            component: () => import('@/pages/manageTool/teamMember')
          },
          {
            name: 'seaHandDeal',
            path: '/manageTool/seaHandDeal',
            component: () => import('@/pages/manageTool/seaHandDeal')
          },
          {
            name: 'manualDistribution',
            path: '/manageTool/manualDistribution',
            component: () => import('@/pages/manualDistribution')
          },
          {
            name: 'ccManualDistribution',
            path: '/manageTool/ccManualDistribution',
            component: () => import('@/pages/ccManualDistribution')
          },
          {
            name: 'privateSeaDetail',
            path: '/manageTool/privateSeaDetail',
            component: () => import('@/pages/manageTool/privateSeaDetail')
          },
          {
            name: 'permissionlist',
            path: '/manageTool/permissionlist',
            component: () => import('@/pages/permissionlist')
          },
          {
            name: 'highPrivateSeaLPManage',
            path: '/manageTool/highPrivateSeaLPManage',
            component: () => import('@/pages/manageTool/highPrivateSeaLPManage')
          },
          {
            name: 'changeclass',
            path: '/manageTool/changeclass',
            component: () => import('@/pages/changeClass')
          },
          {
            name: 'gradeversionCollect',
            path: '/managetool/gradeversion/collect',
            component: () => import('@/pages/manageTool/gradeversionCollect')
          },
          {
            name: 'academicQuestionnaire',
            path: '/manageTool/academicQuestionnaire',
            component: () => import('@/pages/manageTool/academicQuestionnaire')
          }
        ]
      },
      {
        name: 'dataBoard',
        path: '/dataBoard',
        component: () => import('@/pages/dataBoard'),
        children: [
          {
            path: ':pathMatch(.*)*',
            component: () => import('@/pages/dataBoard/DataBoardCommonPage')
          }
        ]
      }
    ]
  }
];

// 默认路由（不需要权限）
export const routes: RouteRecordRaw[] = [
  {
    name: 'redirect',
    path: '/redirect',
    component: Empty
  },
  {
    name: 'notFound',
    path: '/:pathMatch(.*)*',
    component: () => import('../pages/notFound/index.jsx')
  },
  {
    name: 'stopServe',
    path: '/stopServe',
    component: () => import('../pages/stopServe/index.jsx')
  },
  { name: 'answerReport', path: '/answerReport', component: () => import('../pages/report/answerReport') },
  {
    name: 'test',
    path: '/test',
    // component: () => import('@/pages/test/testTable'),
    redirect: '/test/table',
    children: [
      {
        name: 'table',
        path: 'table',
        component: () => import('../pages/test/testTable')
      },
      {
        name: 'tableObject',
        path: 'tableObject',
        component: () => import('../pages/test/testTableObject')
      },
      {
        name: 'sTable',
        path: 'sTable',
        component: () => import('../pages/test/testSTable')
      },
      {
        name: 'tableLoading',
        path: 'tableLoading',
        component: () => import('../pages/test/testTableLoading')
      },
      {
        name: 'tableVirtual',
        path: 'tableVirtual',
        component: () => import('../pages/test/testTableVirtual')
      },
      {
        name: 'form',
        path: 'form',
        component: () => import('../pages/test/form')
      },
      {
        name: 'correction-notebook',
        path: 'correction-notebook',
        component: () => import('../pages/demos/correction-notebook')
      }
    ]
  },
  {
    name: 'demo4lff',
    path: '/demo4lff',
    component: () => import('../pages/demos/demo4lff')
  },
  {
    name: 'cardDemo',
    path: '/cardDemo',
    component: () => import('../pages/demos/cardDemo')
  },
  {
    name: 'demoEmoji',
    path: '/demoEmoji',
    component: () => import('../pages/demoEmoji/EmojiDemo')
  },
  {
    name: 'student-detail',
    path: '/student-detail/:stu_id?',
    component: () => import('@/pages/studentDetail')
  },
  {
    name: 'student-data',
    path: '/student-data',
    component: () => import('../components/studentDetail/performance/components/studentData')
  },
  {
    name: 'all-search',
    path: '/allSearch',
    component: () => import('@/pages/tools/all-search')
  },
  {
    name: 'wrongCollectionResult',
    path: '/wrongCollectionResult',
    meta: { auth: false },
    component: () => import('@/pages/wrongCollectionResult/index.tsx')
  },
  {
    name: 'tasks',
    path: '/tasks',
    component: () => import('@/pages/myTask/index')
  },
  // 回放跟课
  {
    name: 'replayCourse',
    path: '/tasks/replayCourse',
    component: () => import('../pages/myTask/replayCourse')
  },
  // 批改
  {
    name: 'correctOverview',
    path: '/tasks/correctOverview',
    component: () => import('../pages/myTask/correctOverview')
  },
  // 触达
  {
    name: 'stuTouch',
    path: '/tasks/stuTouch',
    component: () => import('../pages/myTask/stuTouch')
  },
  {
    name: 'tools',
    path: '/mediaRecorder',
    component: () => import('../pages/tools/mediaRecorder')
  },
  // 开发使用，提测使需加权限
  // {
  //   name: 'manualDistribution',
  //   path: '/manualDistribution',
  //   component: () => import('@/pages/manualDistribution')
  // },
  {
    name: 'uploadImage',
    path: '/uploadImage',
    component: () => import('@/components/singleTools/uploadImage')
  },
  // {
  //   name: 'refundReview',
  //   path: '/refundReview',
  //   component: () => import('@/pages/refundReview/index')
  // },
  {
    name: 'refoudTree',
    path: '/refoudTree',
    component: () => import('@/components/tableCap/row/RefundReasonTree')
  },
  // {
  //   name: 'micro-receipt',
  //   path: '/microReceipt',
  //   component: () => import('@/pages/tools/micro-receipt')
  // }
  {
    name: 'mySea',
    path: '/mySea',
    component: () => import('@/pages/enrollment/myPrivateSea')
  },

  {
    name: 'TestAntd',
    path: '/TestAntd',
    component: () => import('@/pages/test/test_antd')
  },
  {
    name: 'DiagnosisModal',
    path: '/DiagnosisModal',
    component: () => import('@/pages/myClass/components/diagnosisModal/index')
  },
  {
    name: 'AcademicDiagnosisModal',
    path: '/AcademicDiagnosisModal',
    component: () => import('@/pages/myClass/components/academicDiagnosisModal')
  },
  {
    name: 'correction-notebook',
    path: '/test-correction-notebook',
    component: () => import('@/pages/test/correction-notebook')
  },
  {
    name: 'cps-detail',
    path: '/commonTools/cps/detail',
    component: () => import('@/pages/tools/cpsPoster/detail.jsx')
  },
  {
    name: 'sms-detail',
    path: '/commonTools/smsRecord/detail',
    component: () => import('@/pages/tools/smsRecord/detail.jsx')
  }
];

export const router = createRouter({
  history: createWebHashHistory(),
  routes: routes
});

export type RouterType = RouteRecordRaw & { mate?: string; children?: RouterType };

router.beforeEach(async (to, from, next) => {
  const common = commonStore();
  const login = useLoginProvide();
  if (common.hasLogin) {
    // 设置当前页面权限信息
    // 单独权限处理
    if (/^\/myClass\/(.+)/.test(to.fullPath)) {
      to.meta.auth && common.setCurAuth(getPath('/myClass'));
    } else if (/^\/newMyClass\/(.+)/.test(to.fullPath)) {
      to.meta.auth && common.setCurAuth(getPath('/newMyClass'));
    } else {
      to.meta.auth && common.setCurAuth(getPath(to.fullPath));
    }

    next();
  } else {
    login.toLoginOut();
  }
});

export default router;
